import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/imgs/headshots/george-kaye.jpg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Photo of George Kaye"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "George Kaye"),
  /*#__PURE__*/_createElementVNode("h3", null, "CEO"),
  /*#__PURE__*/_createElementVNode("p", null, "George Kaye started his career at Credit Suisse First Boston’s Product Development Group in 1999, quickly specialising in equity derivatives. In 2006, he left to join the Derivative Analysis Group of Goldman Sachs, where he focused on building a methodology for model risk analysis of the firm's equity derivatives positions. In 2010 he returned to the front office, working in the equity derivatives section of the Quantitative Analysis Group of UBS, leaving at the end of 2011 to build his own derivatives software company.")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_profile = _resolveComponent("profile")!

  return (_openBlock(), _createBlock(_component_profile, null, {
    headshot: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _hoisted_2
    ]),
    _: 1
  }))
}